import { StylesConfig } from 'react-select';
import styled from 'styled-components';

import ReactSelect from 'dashboard/components/ReactSelect';
import { Z_INDICES } from 'dashboard/styles/variables';
import Tooltip from 'design-system/components/Tooltip';

const Row = styled.div`
  grid-column: 1 / 7;
  user-select: none;
`;

// Select is a block element, and it uses a forward ref to bypass its own Wrapper components
// This makes it impossible to re-style with styled-components
// So we wrap the Select's Wrapper with our own Wrapper, to behave more like we expect
const SelectWrapper = styled.div`
  display: inline-block;
  width: 75px;
`;

const HopsTextWithTooltip = styled.div`
  margin-right: 4px;
  text-decoration: underline;
  text-decoration-style: dashed;
  text-underline-offset: 2px;
  text-decoration-thickness: 1px;
`;

const reactSelectStyles: StylesConfig = {
  singleValue: (styles) => ({
    ...styles,
    color: '#0E0E11',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '125%',
  }),
  control: () => ({
    height: '32px',
  }),
};

const TOOLTIP_Z_INDEX = Z_INDICES.modal + 500;

const NUM_HOPS_OPTIONS = ['2', '4', '6', '8', '10', '20', '50'];

const NumHops = ({ numHops, onChange }: { numHops: number; onChange: (n: number) => void }) => {
  const onNumHopsChange = (newValue: string) => {
    onChange(Number(newValue));
  };

  return (
    <Row>
      At most{' '}
      <SelectWrapper>
        <ReactSelect
          classNamePrefix='GraphEditorDropdown'
          value={numHops.toString()}
          onChange={onNumHopsChange}
          options={[...NUM_HOPS_OPTIONS].map((numHops) => {
            return {
              label: numHops,
              value: numHops,
            };
          })}
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          styles={reactSelectStyles}
          portal
        />
      </SelectWrapper>{' '}
      <Tooltip
        iconTrigger={<HopsTextWithTooltip>hops</HopsTextWithTooltip>}
        portal={true}
        side='top'
        zIndex={TOOLTIP_Z_INDEX}
      >
        The number of edge connections from
        <br />
        the starting node to the terminal node
      </Tooltip>{' '}
      away
    </Row>
  );
};

export default NumHops;
